import { useEffect, useState } from "react";
import { Auth, ProgressBar } from '@spendlevel/shared-login-frontend';
import { useLocation, useNavigate } from "react-router-dom";
import { CodeInput } from "@spendlevel/shared-login-frontend";

function Mfa() {
    const [errorMsgHidden, setErrorMsgHidden] = useState('none');
    const [errorMsg, setErrorMsg] = useState('');
    const navigate = useNavigate();
    const location = useLocation();
    const [showProgressBar, setShowProgressBar] = useState(false);
    
    
    const handleCodeChanged = async (value: string) => {
        setErrorMsgHidden('none');
    }

    const handleCodeCompleted = async (value: string) => {
        setShowProgressBar(true);

        const result = await Auth.confirmMFACode('admin', value);

        if (result?.status === 'Success') {
            //window.location.href = '/secure';
            navigate('/iframe');
        }

        setShowProgressBar(false);

        if (result?.errorMsg) {
            setErrorMsg(result.errorMsg);
            setErrorMsgHidden('contents');
            return false;
        }

        return true;
    }

    useEffect(() => {
        document?.querySelector('html')?.setAttribute('data-bs-theme', 'dark');

        if (!location.state?.isMfa) {
            navigate('/');
        }

        // If the user is already authenticated, redirect to secure resource
        (async () => {
            if (await Auth.isAuthenticated('admin')) {
                //window.location.href = '/secure';
                navigate('/iframe');
            }
        })();
    });

    return (
        <div className="login login-v2 fw-bold">
            <div className="login-cover">
                <div className="login-cover-img" style={{ backgroundImage: 'url(/assets/login-bg-17.jpg)' }}></div>
                <div className="login-cover-bg">{showProgressBar && <ProgressBar/>}</div>
            </div>

            <div className="login-container">
                <div className="login-header">
                    <div className="brand" style={{padding: 0, fontWeight:300, flex: 1, fontSize: '12px'}}>
                        <div className="d-flex flex-column align-items-center" style={{justifyContent: 'center', paddingBottom: '10px'}}>
                            <small>Enter your MFA code from Google Authenticator</small>
                        </div>
                        <div className="d-flex flex-column align-items-center" style={{justifyContent: 'center'}}>
                            <div className="d-flex justify-content-center align-items-center" style={{width: '400px', paddingBottom: '12px'}}>
                                <CodeInput onCodeChanged={handleCodeChanged} onCodeCompleted={handleCodeCompleted} />
                            </div>
                            <div style={{justifyContent: 'center'}}>
                                <span style={{textAlign: 'center', display: errorMsgHidden}}>
                                    <div className="alert alert-danger" style={{border: '1px solid #ff9d9a', fontWeight: '400 !important'}}>Authorization failed.  { errorMsg }.</div>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Mfa;